import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const mcpAccountEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('mcpAccountEntitlementsState', undefined);

export const mcpAccountEntitlementsStateActions = mcpAccountEntitlementsStateSlice.actions;
export const mcpAccountEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.userPage.tabs.userEntitlements.mcp.accountEntitlements.state;
